<div class="d-flex flex-column flex-root" id="kt_login_wrapper">
	<div class="login login-3 login-signin-on d-flex flex-column flex-lg-row flex-row-fluid bg-white" id="kt_login">
		<!--begin::Aside-->
		<div class="login-aside d-flex flex-row-auto bgi-size-cover bgi-no-repeat p-10 p-lg-10"
			style="background-image: url(../../../../assets/media/images/background.jpg);">
			<!--begin: Aside Container-->
			<div class="d-flex flex-row-fluid flex-column mt-10">
				<!--begin: Aside header-->
				<a href="#" class="text-center">
                    <img src="./assets/media/logos/logo1.png" class="max-h-70px" alt="" />
                </a>
				<!--end: Aside header-->
			</div>

		</div>
		<!--begin::Aside-->

		<!--begin::Content-->
		<div class="flex-row-fluid d-flex flex-column position-relative p-7 overflow-hidden">
			<router-outlet></router-outlet>
		</div>
		<!--end::Content-->
	</div>
</div>
